<script setup>
import {onBeforeMount, ref, reactive, nextTick} from "vue";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTInvoiceState from "@/components/YTInvoiceState/index.vue"
import {listInvoice} from "@/api/invoice/invoice.js";

/*初次加载*/
onBeforeMount(async() => {
  await nextTick(async () => {
    await handleSearch()
  })
})

// 商品分类枚举
const invoiceType = ref([
  {
    label: "蓝票",
    value: 1,
  },
  {
    label: "红票",
    value: 2,
  }
])

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  invoiceType: null,
});

// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listInvoice(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.invoiceType = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '订单编号', key: 'orderNo', nowrap: true },
  { title: '发票号码', key: 'invoiceNo', nowrap: true },
  { title: '金额', key: 'amountWithTax', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 编辑商品信息
const handleEditItem = (info) => {
  router.push({path: "/editInvoice", query: {invoiceId: info.invoiceId}})
}

</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="6">
                    <v-text-field
                        v-model="formData.keyword"
                        placeholder="请输入订单编/发票号码/发票代码"
                        label="订单编编号/发票号码/发票代码"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.invoiceType"
                        placeholder="选择发票类型"
                        variant="outlined"
                        label="发票类型"
                        clearable
                        :items="invoiceType"
                        item-title="label"
                        item-value="value"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'adminInvoice:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'adminInvoice:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.state="{ item }">
            <div>
              <YTInvoiceState :state="item.state"></YTInvoiceState>
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon class="mg_r_1" icon="mdi-file-edit-outline" color="primary" size="small" @click="handleEditItem(item)" v-show="$handleHasBtnPermission('all', 'adminInvoice:view:edit')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>